import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from '../user/user.service';
import { ApiService } from '../../api/api.service';
import { AUTH_ENDPOINTS } from '../../api/endpoints/auth.endpoints';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private loggedInUser = new BehaviorSubject(
    this.userService.getCurrentUser() ?? null,
  );
  private api = inject(ApiService);
  currentLoggedInUser = this.loggedInUser.asObservable();

  constructor(private userService: UserService) {}

  authLogin(data: any): Observable<any> {
    return this.api.post(AUTH_ENDPOINTS.V1.LOGIN, data);
  }

  setLoggedInUser(user) {
    this.loggedInUser.next(user);
  }

  recoverPaswword(data: any): Observable<any> {
    return this.api.post(AUTH_ENDPOINTS.V1.RECOVER_PASSWORD, data);
  }

  resetPassword(data: any): Observable<any> {
    return this.api.post(AUTH_ENDPOINTS.V1.RESET_PASSWORD, data);
  }

  updateUserData(id: number, data: any): Observable<any> {
    return this.api.put(AUTH_ENDPOINTS.V1.UPDATE_USER_DATA(id), data);
  }

  public isAuthenticated(): boolean {
    return this.userService.isAuthenticated();
  }

  refreshToken(refreshToken): Observable<any> {
    return this.api.post(AUTH_ENDPOINTS.V1.REFRESH, { refresh: refreshToken });
  }
}
